
<div class="content-wrap">
    <div id="content" class="content admin_tool_content">
        <div class="">
            <h1 class="page-title pl0">Data Transfer<span class="fw-semi-bold"></span></h1>
            <section class="widget overflow-auto">
                <header>
                    <h5 class="mb30 pt10">Transfer data from <span class="fw-500 underline">source</span> project to
                        <span class="fw-500 underline">target</span> project</h5>
                </header>
                <div class="widget-body">
                    <form class="form-horizontal" role="form">
                        <fieldset>
                            <div class="form-group">
                                <label for="normal-field" class="col-sm-2 control-label">Source LEED ID</label>
                                <div class="col-sm-7">
                                    <input [(ngModel)]="source_leed_id" type="text" id="normal-field" class="form-control"
                                        placeholder="Enter LEED ID" [ngModelOptions]="{standalone: true}">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="normal-field" class="col-sm-2 control-label">Target LEED ID</label>
                                <div class="col-sm-7">
                                    <input [(ngModel)]="destonation_leed_id" type="text" id="normal-field"
                                        class="form-control" placeholder="Enter LEED ID" [ngModelOptions]="{standalone: true}">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-sm-7">
                                    <div [ngClass]="loader ? 'not-active' : ''">
                                        <ul style="padding-left: 0px;" class="wizard display-block pull-left mr10">
                                            <li class="next list_style_none align-right">
                                                <button (click)="transferData()" class="btn btn-default">Start</button>
                                            </li>
                                        </ul>
                                        <div *ngIf="loader" class="dataInputLoaderSpinner pull-left"></div>
                                    </div>
                                </div>
                            </div>

                        </fieldset>
                    </form>
                </div>
            </section>
        </div>
    </div>
</div>